<template>
  <div class="proactive-container" v-if="messages.length">
    <div
      v-for="msg in messages"
      :key="msg.id"
      class="proactive-item"
    >
      <strong>{{ msg.author }}:</strong> {{ msg.text }}
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  messages: {
    type: Array,
    default: () => []
  }
})
</script>

<style>
.proactive-container {
  position: fixed;
  bottom: 150px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 11000;
}
.proactive-item {
  background: #fff;
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  max-width: 280px;
  font-size: 14px;
}
</style>